export const LOGIN = "/";
export const FORGOT_PASSWORD = "/forgotPassword";
export const RESET_PASSWORD = "/resetPassword";
export const ONE_TIME_PASSWORD = "/oneTimePassword";
export const CONFIRMATION = "/confirmation";
export const PERMISSION = "/permission";

export const HOME = "/home";
export const USER_MANAGEMENT = "/userManagement";
export const ROLE_MANAGEMENT = "/roleManagement"
